// Vietnam (+7) calendar dates as 'YYYY-MM-DD' strings, independent of the browser timezone.
// Vietnam has no daylight saving, so a fixed offset is exact; all arithmetic is done on
// UTC-anchored Date objects so nothing ever passes through the browser's local timezone.
const VN_OFFSET_MS = 7 * 60 * 60 * 1000;

const pad = (n) => String(n).padStart(2, '0');
const fmt = (y, m, d) => `${y}-${pad(m)}-${pad(d)}`;
const fromUtc = (date) => fmt(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());

/** Today's Vietnam calendar date as {y, m, d} (m is 1-12). */
export const vnNow = () => {
  const shifted = new Date(Date.now() + VN_OFFSET_MS);
  return { y: shifted.getUTCFullYear(), m: shifted.getUTCMonth() + 1, d: shifted.getUTCDate() };
};

export const todayVN = () => {
  const { y, m, d } = vnNow();
  return fmt(y, m, d);
};

export const daysAgoVN = (n) => {
  const { y, m, d } = vnNow();
  return fromUtc(new Date(Date.UTC(y, m - 1, d - n)));
};

export const startOfMonthVN = () => {
  const { y, m } = vnNow();
  return fmt(y, m, 1);
};

export const startOfQuarterVN = () => {
  const { y, m } = vnNow();
  return fmt(y, Math.floor((m - 1) / 3) * 3 + 1, 1);
};

export const startOfYearVN = () => fmt(vnNow().y, 1, 1);

/** [first day, last day] of the previous month. */
export const lastMonthRangeVN = () => {
  const { y, m } = vnNow();
  const first = new Date(Date.UTC(y, m - 2, 1));          // month index m-2 = previous month
  const last = new Date(Date.UTC(y, m - 1, 0));           // day 0 of this month = last day of previous
  return [fromUtc(first), fromUtc(last)];
};
